import React from "react";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
import { Link } from "@/components/common/Link";
export default function FaqHero() {
  return <section id="faqhero" data-nav="light" className="relative overflow-hidden bg-background py-16 text-foreground md:py-24 lg:py-28 isolate">
      {/* Decorative subtle layered isometric glass planes */}
      <div className="pointer-events-none absolute inset-0 -z-10 overflow-hidden" aria-hidden="true">
        <div className="absolute -top-24 left-1/2 h-96 w-[48rem] -translate-x-1/2 rounded-full bg-secondary/40 blur-3xl" />
        <div className="absolute top-12 right-10 h-64 w-64 rounded-3xl border border-border/40 bg-card/40 shadow-xs backdrop-blur-xs -rotate-6 hidden md:block" />
        <div className="absolute bottom-6 left-12 h-52 w-52 rounded-3xl border border-border/50 bg-secondary/30 shadow-xs backdrop-blur-xs rotate-12 hidden md:block" />
      </div>

      <div className="container mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <div className="relative z-10 flex flex-col items-center text-center">
          {/* Breadcrumb Navigation */}
          <div className="mb-6 inline-flex items-center rounded-full border border-border/60 bg-card/80 px-4 py-1.5 shadow-2xs backdrop-blur-sm">
            <Breadcrumb>
              <BreadcrumbList className="text-xs sm:text-sm font-sans text-muted-foreground">
                <BreadcrumbItem>
                  <BreadcrumbLink asChild>
                    <Link to="/" className="text-muted-foreground hover:text-foreground">
                      Home
                    </Link>
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbSeparator />
                <BreadcrumbItem>
                  <span className="text-muted-foreground">Resources</span>
                </BreadcrumbItem>
                <BreadcrumbSeparator />
                <BreadcrumbItem>
                  <BreadcrumbPage className="font-medium text-foreground">
                    FAQ
                  </BreadcrumbPage>
                </BreadcrumbItem>
              </BreadcrumbList>
            </Breadcrumb>
          </div>

          {/* H1 Heading */}
          <h1 className="font-serif text-4xl font-semibold tracking-tight sm:text-5xl md:text-6xl text-foreground">
            Remodeling FAQ
          </h1>

          {/* Intro Paragraph */}
          <p className="mt-5 max-w-2xl font-sans text-base leading-relaxed text-muted-foreground sm:text-lg md:text-xl">
            Clear answers about our design-build process, project budgeting, timelines, permits, and what to expect when renovating your home in Decatur.
          </p>
        </div>
      </div>
    </section>;
}